import styled from 'styled-components'

const SubscriptionsAside = styled.div`
  padding: 34px 24px 34px;
`
export default SubscriptionsAside
